function initializeNotificationLogs() {
  console.log("Initializing notification logs...");

  // Copy device ID to clipboard functionality
  const copyButtons = document.querySelectorAll(".copy-device-id");
  console.log("Found copy buttons:", copyButtons.length);

  copyButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const deviceId = this.dataset.deviceId;
      console.log("Copying device ID:", deviceId);

      navigator.clipboard
        .writeText(deviceId)
        .then(() => {
          const icon = this.querySelector("i");
          const originalClass = icon.className;

          // Show success feedback
          icon.className = "bi bi-check";
          this.classList.add("btn-success");
          this.classList.remove("btn-outline-secondary");

          // Reset after 2 seconds
          setTimeout(() => {
            icon.className = originalClass;
            this.classList.remove("btn-success");
            this.classList.add("btn-outline-secondary");
          }, 2000);

          console.log("Device ID copied successfully");
        })
        .catch((err) => {
          console.error("Failed to copy device ID:", err);
          alert("Не вдалося скопіювати токен");
        });
    });
  });
}

// Initialize on DOMContentLoaded
document.addEventListener("DOMContentLoaded", function () {
  console.log("DOMContentLoaded event fired");
  initializeNotificationLogs();
});

// Re-initialize on Turbolinks page load
document.addEventListener("turbolinks:load", function () {
  console.log("Turbolinks load event fired");
  initializeNotificationLogs();
});

// Re-initialize on Turbo page load
document.addEventListener("turbo:load", function () {
  console.log("Turbo load event fired");
  initializeNotificationLogs();
});

console.log("Notification logs script loaded");
